(function () {

  const TK_GEBUEHR_VARIANT_ID = 53909696676167;
  const TK_PROPERTY_KEY      = '_tk_gebuehr';
  const DEBOUNCE_MS          = 800;

  let syncTimer = null;

  async function syncTiefkuehl() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();

      const hasTiefkuehl = cart.items.some(
        item => item.properties &&
                item.properties[TK_PROPERTY_KEY] !== undefined &&
                item.variant_id !== TK_GEBUEHR_VARIANT_ID
      );

      const gebuehrItem = cart.items.find(
        item => item.variant_id === TK_GEBUEHR_VARIANT_ID
      );
      const currentQty = gebuehrItem ? gebuehrItem.quantity : 0;
      const requiredQty = hasTiefkuehl ? 1 : 0;

      console.log('[frozen] hasTK:', hasTiefkuehl, 'current:', currentQty, 'required:', requiredQty);

      if (currentQty === requiredQty) return;

      const updateResp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [TK_GEBUEHR_VARIANT_ID]: requiredQty } })
      });
      const updatedCart = await updateResp.json();

      // Warenkorb-Zähler aktualisieren
      document.querySelectorAll('.header__cart-count-number').forEach(
        el => el.textContent = updatedCart.item_count
      );

      // Cart Drawer neu laden (Canopy Theme)
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));

      if (window.location.pathname === '/cart') {
        window.location.replace(window.location.href);
      }

    } catch (err) {
      console.error('[frozen] Fehler:', err);
    }
  }

  function debouncedSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncTiefkuehl, DEBOUNCE_MS);
  }

  window.addEventListener('load', syncTiefkuehl);
  document.addEventListener('on:line-item:change', debouncedSync);
  document.addEventListener('on:cart:add', debouncedSync);
  document.addEventListener('on:cart:update', debouncedSync);
  document.addEventListener('dispatch:cart-drawer:refresh', debouncedSync);

})();